import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=14000ce2&scoped=true&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessage.vue?vue&type=style&index=0&id=14000ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14000ce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14000ce2')) {
      api.createRecord('14000ce2', component.options)
    } else {
      api.reload('14000ce2', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=14000ce2&scoped=true&", function () {
      api.rerender('14000ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ErrorMessage.vue"
export default component.exports